require("!!C:\\Users\\TEJADA\\Desktop\\PROYECTOS MGS\\imm\\V3\\front\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\TEJADA\\Desktop\\PROYECTOS MGS\\imm\\V3\\front\\node_modules\\raw-loader\\index.js!C:\\Users\\TEJADA\\Desktop\\PROYECTOS MGS\\imm\\V3\\front\\node_modules\\@ngtools\\webpack\\src\\index.js!C:\\Users\\TEJADA\\Desktop\\PROYECTOS MGS\\imm\\V3\\front\\src\\vendor.ts"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/vendor.ts
// module id = 785
// module chunks = 5